import React from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import type { PublicChargingType } from "../../../../../../../../common-deprecated/types/SettingsType";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import styles from "./Charging.module.scss";
import { useCarConfigLabel } from "../../../../../utils/labelUtils";

type ChargingPublicProps = {
    chargingAceData: PublicChargingType;
    changeTabFunction: () => void;
    hasHomeChargers: boolean;
};
const ChargingPublic: React.FC<ChargingPublicProps> = (props) => {
    const { changeTabFunction, chargingAceData, hasHomeChargers } = props;

    const [carConfigPublicChargingLearnMore, carConfigWantToChargeAtHome] = useCarConfigLabel([
        "carConfigPublicChargingLearnMore",
        "carConfigWantToChargeAtHome",
    ]);

    return (
        <>
            <div>
                <Text variant="apheleia-body" spacing="spacing-2">
                    {chargingAceData.publicChargingAbout}
                </Text>

                <Button variant="apheleia-text" href={chargingAceData.publicChargingAboutUrl} target="_blank">
                    {carConfigPublicChargingLearnMore}
                    <Icon variant="external" sizing="sm" aria-hidden="true" />
                </Button>
            </div>

            {(chargingAceData.publicChargingTitle || chargingAceData.publicChargingFeatures?.length > 0) && (
                <div className={styles.card}>
                    <Text variant="apheleia-body-large" spacing="spacing-2">
                        {chargingAceData.publicChargingTitle}
                    </Text>

                    {chargingAceData.publicChargingFeatures?.length > 0 && (
                        <div className={styles.rte}>
                            {/* Role list needed for accessibility (mainly in safari)*/}
                            {/* eslint-disable-next-line jsx-a11y/no-redundant-roles*/}
                            <ul role="list">
                                {chargingAceData.publicChargingFeatures.map((feature, index) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <li key={`feature-${index}`}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}

            {/* Don't show 'Go to homechargers block' when there are no homechargers available */}
            {hasHomeChargers && (
                <div className={styles.box}>
                    <Text variant="apheleia-body" spacing="spacing-2">
                        {chargingAceData.homeChargingAbout}
                    </Text>
                    <Button variant="apheleia-text" onClick={changeTabFunction}>
                        {carConfigWantToChargeAtHome}
                    </Button>
                </div>
            )}
        </>
    );
};

export default ChargingPublic;
